export default "__VITE_ASSET__CRMgBt7M__"